import WorkAdvancedSelector from './work-advanced-selector.vue'

WorkAdvancedSelector.install = function (Vue) {
	Vue.component(WorkAdvancedSelector.name, WorkAdvancedSelector);
}

export default WorkAdvancedSelector;